(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchDetailController', GpfsBatchDetailController);

    GpfsBatchDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GpfsBatch'];

    function GpfsBatchDetailController($scope, $rootScope, $stateParams, previousState, entity, GpfsBatch) {
        var vm = this;

        vm.gpfsBatch = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:gpfsBatchUpdate', function(event, result) {
            vm.gpfsBatch = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
